import { BASE_API_URL } from '@src/constants'
import { ax } from '@src/utils/axios/axios'

export interface DRSAuditEntry {
  id: string
  sourceTable: 'DRSMaterialCostSummary' | 'DRSMobileAssetCostSummary' | 'DRSSubcontractorCostSummary' | 'DRSLabourCostSummary'
  drsSummaryId: number
  workType: string | null
  operation: 'INSERT' | 'UPDATE' | 'DELETE'
  oldTotalCost: string | null
  newTotalCost: string | null
  oldPlanTotalCost: string | null
  newPlanTotalCost: string | null
  changedBy: string | null
  changedAt: string
}

interface AuditOptions {
  drsSummaryId: string | number
  limit?: number
}

export const apiDRSAudit = ({ drsSummaryId, limit }: AuditOptions) => {
  return ax({
    method: 'GET',
    url: `${BASE_API_URL}/drs`,
    params: {
      drs: drsSummaryId,
      audit: 1,
      ...(limit ? { limit } : {}),
    },
  })
}
